<template>
  <div class="boxWrapper">
    <van-form ref="formRef" @submit="onSubmit" :show-error="false">
      <div class="box">
        <div class="title">
          <span class="icon"></span>
          购课信息
        </div>
        <div class="content">
          <div class="subTitle">课程名称</div>
          <van-field
            clickable
            readonly
            name="productName"
            :value="redenpPoductName(detail.productName)"
            placeholder="点击选择课程"
            @click="showCoursePicker = true"
          />
          <van-popup v-model="showCoursePicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="courseList"
              @confirm="onSelectCourse"
              @cancel="showCoursePicker = false"
            />
          </van-popup>
          <div v-if="rederSubjectItem(detail)">
            <div class="subTitle">科目</div>
            <van-field
              clickable
              readonly
              name="subjectName"
              :value="detail.subjectName"
              placeholder="请选择科目"
              :rules="[{ required: true, message: '请选择科目' }]"
              @click="showSubjectPicker = true"
            />
          </div>
          <van-popup v-model="showSubjectPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="subjectList"
              @confirm="onSelectSubject"
              @cancel="showSubjectPicker = false"
            />
          </van-popup>
          <div class="subTitle">用于进群的微信名</div>
          <van-field
            v-model="detail.wxUserName"
            name="wxUserName"
            placeholder="微信名"
            maxlength="20"
            :rules="[{ required: true, message: '请填写微信名' }]"
          />
          <div class="subTitle">订单截图凭证</div>
          <UploadImage
            :maxNum="5"
            @getListFile="getListFile"
            :fileList="detail.orderImgList"
          />
          <div :class="['tooltip', 'topMargin']">查询入口：打开哔哩哔哩-首页-右上角-哔哩哔哩课堂-课程购买成功</div>
        </div>
      </div>

      <div class="box">
        <div class="title">
          <span class="icon"></span>
          订单信息
        </div>
        <div class="content">
          <div class="subTitle">下单UID</div>
          <van-field
            v-model="detail.buserId"
            type="number"
            name="buserId"
            placeholder="请输入"
            maxlength="20"
            :rules="[{ required: true, message: '请填写UID' }]"
          />
          <div class="tooltip">查询入口：打开哔哩哔哩-我的-设置-账号资料-UID</div>
          <div class="subTitle">购买订单号</div>
          <van-field
            v-model="detail.borderNo"
            name="borderNo"
            placeholder="请输入"
            maxlength="30"
            :rules="[{ required: true, message: '请填写订单号' },{ required: true, message: '订单号格式错误，请输入正确的订单号',pattern: /^\d{17}$/,trigger: 'onSubmit'}]"
          />
          <div class="tooltip">查询入口：打开哔哩哔哩-首页-右上角-哔哩哔哩课堂-课程购买成功</div>
        </div>
      </div>

      <div class="box">
        <div class="title">
          <span class="icon"></span>
          收货信息
        </div>
        <div class="content">
          <div class="subTitle">姓名</div>
          <van-field
            v-model="detail.consignee"
            name="consignee"
            placeholder="请输入"
            maxlength="20"
            :rules="[{ required: true, message: '请填写姓名' }]"
          />
          <div class="subTitle">手机号</div>
          <van-field
            v-model="detail.phone"
            name="phone"
            placeholder="请输入"
            maxlength="20"
            :rules="[{ required: true, message: '请填写手机号' }]"
          />
          <div class="subTitle">所在地区</div>
          <van-field readonly :rules="[{ required: true, message: '请选择地区' }]" clickable :value="local" right-icon="arrow" name="local" placeholder="点击选择省市区" @click="showArea = true" />
          <van-popup v-model="showArea" position="bottom">
            <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
          </van-popup>
          <div class="subTitle">详细地址</div>
          <van-field
            v-model="detail.addressDetail"
            name="addressDetail"
            placeholder="请输入"
            type="textarea"
            autosize
            maxlength="255"
            :rules="[{ required: true, message: '请填写详细地址' }]"
          />
        </div>
      </div>

      <div class="footer">
        <div @click="onClickBtn" class="btn">提交</div>
      </div>
    </van-form>
  </div>
</template>

<script>
import {
  reqBilibiliOrderSave,
  reqBilibiliOrderEdit,
} from '@/api/bilibiliShipments/index';
import UploadImage from '@/components/UploadImage/index.vue';
import { areaList } from '@vant/area-data';

const englishSubjectList = ['英语一', '英语二'];
const mathematicsSubjectList = ['数学一', '数学二', '数学三'];
const courseListPreFix = {
  4324: ['25考研数学全程班'],
  4318: ['25考研英语全程班'],
  4409: ['25考研政治全程班'],
  16956: ['25考研408计算机全程班'],
  17400: ['25考研396经综全程班'],
};
const subjectListPreFix = {
  4324: mathematicsSubjectList,
  4318: englishSubjectList,
};

const allSubjectList = {
  4324: '数学',
  4318: '英语',
  4409: '政治',
  1452: '英语',
  16956: '计算机',
  17400: '经综',
};

// 英语4318
// 4324
// 政治4409

// 2024考研语法阅读精讲班：1452
// 2024考研高等数学精讲班：1418

export default {
  data() {
    return {
      local: '',
      showArea: false,
      areaList,
      courseId: this.$route.query.courseId || 1452,
      showCoursePicker: false,
      showSubjectPicker: false,
      courseList: ['2024考研语法阅读精讲班'], // 默认：2024考研语法阅读精讲班
      subjectList: ['英语一', '英语二'], // 默认： ['英语一', '英语二']
      ignoreSubjectCourse: [4409, 16956, 17400], // 不需要展示科目的课程
      ignoreSubject: ['政治', '计算机', '经综'],
    };
  },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    onSuccess: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    detail() {
      this.initData();
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    // 省市区确认
    onConfirm(values) {
      this.detail.province = values[0]?.name;
      this.detail.city = values[1]?.name;
      this.detail.area = values[2]?.name;
      this.local = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join(' ');
      this.showArea = false;
    },
    rederSubjectItem(detail) {
      if (this.ignoreSubject.includes(detail.disciplineName)) {
        return false;
      }
      // if (Number(this.courseId) === this.ignoreSubjectCourse[0]) {
      if (this.ignoreSubjectCourse.includes(Number(this.courseId))) {
        return false;
      }
      return true;
    },
    redenpPoductName(name) {
      return name || this.courseList[0];
    },
    initData() {
      if (this.courseId && courseListPreFix[this.courseId]) {
        this.courseList = courseListPreFix[this.courseId];
      }
      if (this.courseId && subjectListPreFix[this.courseId]) {
        this.subjectList = subjectListPreFix[this.courseId];
      }
      if (this.detail?.disciplineName && this.detail?.disciplineName === '数学') {
        this.subjectList = mathematicsSubjectList;
      } else if (this.detail?.disciplineName && this.detail?.disciplineName === '英语') {
        this.subjectList = englishSubjectList;
      }
      if (this.detail?.province) {
        this.local = `${this.detail?.province} ${this.detail?.city} ${this.detail?.area}`;
      }
    },
    async onSubmit(value) {
      if (this.detail.orderImgList?.length === 0) {
        this.$toast('请上传订单截图凭证');
        return;
      }
      const toast1 = this.$toast.loading({
        message: '请求中...',
        forbidClick: true,
      });
      let res;
      // eslint-disable-next-line no-param-reassign
      delete value.local;
      const params = {
        ...this.detail,
        ...value,
        bproductId: this.courseId,
        disciplineName: this.detail?.disciplineName ? this.detail?.disciplineName : allSubjectList[this.courseId],
      };
      if (this.detail.id) {
        res = await reqBilibiliOrderEdit(params);
      } else {
        res = await reqBilibiliOrderSave(params);
      }
      toast1.clear();
      if (res.code === 0) {
        this.onSuccess();
      } else {
        this.$toast(res.msg ?? '请求错误');
      }
    },
    onClickBtn() {
      this.$refs.formRef.submit();
    },
    getListFile(list) {
      this.detail.orderImgList = list;
    },
    onSelectCourse(value) {
      this.detail.productName = value;
      this.showCoursePicker = false;
    },
    onSelectSubject(value) {
      this.detail.subjectName = value;
      this.showSubjectPicker = false;
    },
  },
  components: {
    UploadImage,
  },
};
</script>

<style lang="scss" scoped>

.boxWrapper {
  padding-bottom: 180px;
}
.box {
    margin: 0 36px 22px;
    background: #FFF;
    border-radius: 14px;

    .title {
      padding-top: 33px;
      color: #333;
      font-weight: 500;
      font-size: 33px;

      .icon {
        display: inline-block;
        width: 7px;
        height: 29px;
        margin-right: 29px;
        background: #FF7F41;
      }
    }

    .subTitle {
      margin-top: 29px;
      margin-bottom: 14px;
      font-size: 25px;
    }

    .content {
      padding: 36px;
    }

    .tooltip {
      color: #999;
      font-size: 22px;
      line-height: 31px;
    }

    .topMargin {
      margin-top: 14px;
    }
  }
.footer {
  position: fixed;
  bottom: 0;
  width: 750px;
  height: 167px;
  background: #FFF;
  box-shadow: 0 -4px 18px 0 rgba(0,0,0,0.07);

  .btn {
    width: 678px;
    height: 80px;
    margin: 22px 0 0 36px;
    color: #fff;
    font-size: 29px;
    line-height: 80px;
    text-align: center;
    background: #FF7F41;
    border-radius: 45px;
  }
}
</style>
